import { useEffect } from 'react'
import ReactFlow, { Node, ReactFlowProvider, useReactFlow } from 'reactflow'

import { CarNode } from '../../../components/research/carNode/CarNode'
import { translations } from '../../../configs/translations'
import { useStore } from '../../../store/store'

const donateNodeTypes = { car: CarNode } as const

const DonateFlowCanvas = ({
  viewportX,
  nodes,
}: {
  viewportX: number
  nodes: Node[]
}) => {
  const { setViewport } = useReactFlow()
  
  useEffect(() => {
    const raf = window.requestAnimationFrame(() => {
      setViewport({ x: viewportX, y: 0, zoom: 1 })
    })
  
    return () => window.cancelAnimationFrame(raf)
  }, [viewportX, setViewport])  

  return (
    <ReactFlow
      nodes={nodes}
      edges={[]}
      nodeTypes={donateNodeTypes}
      minZoom={1}
      maxZoom={1}
      panOnDrag={false}
      panOnScroll={false}
      zoomOnScroll={false}
      zoomOnPinch={false}
      nodesDraggable={false}
      nodesConnectable={false}
    />
  )
}

export const DonateResearchTree = ({
  viewportX,
  nodes,
}: {
  viewportX: number
  nodes: Node[]
}) => {
  const language = useStore((state) => state.language) as keyof typeof translations
  const t = translations[language]

  const playWooshSound = () => {
    const wooshSound = new Audio('/sounds/woosh_1.wav')
    wooshSound.volume = 0.01
    wooshSound.playbackRate = 2
    wooshSound.play()
  }

  return (
    <div className="donate-research-tree" onMouseEnter={playWooshSound}>
      <div className="donate-research-tree-header">
        <img src="/icons/256px/prem_leaf.webp" alt="premium leaf" />
        <p>{t.premium_cars}</p>
      </div>

      <div className="donate-research-tree-content">
        <ReactFlowProvider>
          <DonateFlowCanvas viewportX={viewportX} nodes={nodes} />
        </ReactFlowProvider>
      </div>
    </div>
  )
}